import { Button, Col, Row } from '@rocketmakers/armstrong';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { BackButton } from '../../components/buttons/back-button';
import { useRoutePaths } from '../../../../shared/context/paths';
import { routePaths } from '../../routes';
import './meter-type.scss';

export const MeterTypeView: React.FunctionComponent<RouteComponentProps> = () => {
  const { push } = useRoutePaths();
  const handleCurrentTransformerMeters = () => {
    push(routePaths.currentTransformerMeters.model);
  };

  const handleInlineMeters = () => {
    push(routePaths.inlineMeters.root);
  };

  return (
    <div className="meter-type">
      <BackButton />
      <h1>
        Configuration{' '}
        <span className="color-primary">Does the system have Current Transformers or Inline Electricity Meters?</span>
      </h1>
      <Row className="btn-row">
        <Col>
          <Button className="btn-full current-transformer-meters-button" onClick={handleCurrentTransformerMeters}>
            Current Transformer Meters
          </Button>
        </Col>
        <Col>
          <Button className="btn-full inline-meters-button" onClick={handleInlineMeters}>
            Inline Meters
          </Button>
        </Col>
      </Row>
    </div>
  );
};
